import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { BrowserProvider } from "ethers";
import { v4 as uuidv4 } from 'uuid';
import './NoteAppID.css';
import axios from 'axios';
import contractABI from '../Contract/contractABI.json';
 

const PINATA_API_KEY = 'ce6b3b23ffa77501b6a6';
  const PINATA_API_SECRET = '7984d1ed92eb2cc0a0ab87e1a9256bd0145482197b9df1f97c762f5929d5c2bc';
  const contractAddress = '0x99580a51F765B91326C54C16C9a45900A6D7F02d';




const UniqueIdApp = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [noteId, setNoteId] = useState('');
  const [retrievedNote, setRetrievedNote] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // Function to upload content to IPFS via Pinata
  const uploadToIPFS = async (noteContent) => {
    const url = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;
    const data = { note: noteContent };
    const headers = {
      pinata_api_key: PINATA_API_KEY,
      pinata_secret_api_key: PINATA_API_SECRET,
    };

    try {
      const response = await axios.post(url, data, { headers });
      return response.data.IpfsHash;
    } catch (error) {
      console.error('Error uploading to IPFS: ', error);
      return null;
    }
  };

  // Function to store note on the blockchain
  const handleAddNote = async (e) => {
    e.preventDefault();

    if (!window.ethereum) {
      alert('Please install MetaMask!');
      return;
    }

    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();

    const contract = new ethers.Contract(contractAddress, contractABI, signer);

    const ipfsHash = await uploadToIPFS(content);
    if (ipfsHash) {
      const newId = uuidv4();
      console.log(newId);
      console.log(ipfsHash);
      try {
        const tx = await contract.createNote(newId, ipfsHash);
        await tx.wait();
        alert('Note stored successfully!'); 

        setTitle('');
        setContent('');
        setNoteId(newId);
      } catch (error) {
        console.error('Error storing note on blockchain:', error);
        alert('Failed to store the note on the blockchain.');
      }
    } else {
      alert('Failed to upload the note to IPFS.');
    }
  };

  // Function to retrieve note by ID from blockchain
  const handleRetrieveNote = async (e) => {
    e.preventDefault();

    if (!window.ethereum) {
      alert('Please install MetaMask!');
      return;
    }

    const provider = new ethers.BrowserProvider(window.ethereum);
    const contract = new ethers.Contract(contractAddress, contractABI, provider);

    try {
      const note = await contract.getNote(noteId);
      const ipfsHash = note[0];
      console.log("Retrieve")
      console.log(ipfsHash);

      const retrievedContent = await axios.get(`https://ipfs.io/ipfs/${ipfsHash}`);
      setRetrievedNote({ id: noteId, content: retrievedContent.data.note });
    } catch (error) {
      console.error('Error retrieving note:', error);
      alert('Failed to retrieve the note.');
    }
  };

  // Function to edit note
  const handleEditNote = async (e) => {
    e.preventDefault();
    console.log('Jenny jenny jenny');
    //if (!retrievedNote) return;

    const ipfsHash1 = await uploadToIPFS(content);
    console.log('handle note',ipfsHash1);
    if (ipfsHash1) {
      try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, signer);

        const tx = await contract.updateNote(noteId, ipfsHash1);
        console.log(noteId);
        await tx.wait();

        alert('Note updated successfully!');
        setIsEditing(false);
        setTitle('');
        setContent('');
        setNoteId('');
        setRetrievedNote(null);
      } catch (error) {
        console.error('Error updating note on blockchain:', error);
        alert('Failed to update the note on the blockchain.');
      }
    } else {
      alert('Failed to upload the updated note to IPFS.');
    }
  };

  return (
    <div className="app-container">
      <h1 className="header">Note Storage With ID</h1>

      {/* Form to add or edit a note */}
      <form className="note-form" onSubmit={isEditing ? handleEditNote : handleAddNote}>
        <input
          type="text"
          placeholder="Note Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Note Content"
          rows={5}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />
        <button type="submit">{isEditing ? 'Update Note' : 'Add Note'}</button>
      </form>

      {/* Form to retrieve a note by ID */}
      <form className="retrieve-form" onSubmit={handleRetrieveNote}>
        <input
          type="text"
          placeholder="Enter Note ID"
          value={noteId}
          onChange={(e) => setNoteId(e.target.value)}
          required
        />
        <button type="submit">Retrieve Note</button>
      </form>

      {/* Display retrieved note and edit option */}
      {retrievedNote && (
        <div className="retrieved-note">
          <h2>Retrieved Note:</h2>
          <p>{retrievedNote.content}</p>
          <button onClick={() => {
            setIsEditing(true);
            setTitle(title);
            setContent(retrievedNote.content);
          }}>Edit Note</button>
        </div>
      )}
      {noteId && !isEditing && (
      <div className="note-id-display">
        <h2>Your Note ID:</h2>
        <p>{noteId}</p>
      </div>
    )}

    </div>
  );
};

export default UniqueIdApp;




